import Button from '@ingka/button';
import InlineMessage from '@ingka/inline-message';
import pencilIcon from '@ingka/ssr-icon/paths/pencil';
import warningTriangleIcon from '@ingka/ssr-icon/paths/warning-triangle';
import { translate } from '@repo/phrase';

import { useAssetActionButton } from '@/components/asset-details/asset-action-buttons/asset-action-buttons.hooks';
import { modifyAsset } from '@/components/asset-details/asset-action-buttons/asset-action-buttons.utils';

import { useAssetPendingChangesGuard } from '@/hooks/asset-pending-changes-navigation.hooks';
import { useAssetParams } from '@/hooks/asset.hooks';

import styles from './styles.module.scss';

export const AssetActionButtons = () => {
    const { assetId, assetType } = useAssetParams();
    const guardPendingChanges = useAssetPendingChangesGuard();
    const { isButtonDisabled, reasonText, isModificationButtonDisabled, modificationReasonText } =
        useAssetActionButton();

    return (
        <div className={styles.asset_details_action}>
            <Button
                data-testid="action-modify-asset"
                text={translate(`order_sidebar_action_modify_${assetType}`)}
                ssrIcon={pencilIcon}
                disabled={isModificationButtonDisabled || isButtonDisabled}
                type="secondary"
                onClick={() => {
                    guardPendingChanges(() => {
                        modifyAsset(assetType, assetId);
                    });
                }}
                fluid
            />
            {isButtonDisabled && (
                <InlineMessage
                    data-testid="canceled-asset-message"
                    className={String(styles.order_details_action_message)}
                    body={translate(reasonText)}
                    ssrIcon={warningTriangleIcon}
                    variant="informative"
                    subtle
                />
            )}
            {isModificationButtonDisabled && !isButtonDisabled && (
                <InlineMessage
                    data-testid="modify-asset-message"
                    className={String(styles.order_details_action_message)}
                    body={translate(modificationReasonText)}
                    ssrIcon={warningTriangleIcon}
                    variant="informative"
                    subtle
                />
            )}
        </div>
    );
};
